import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class DownloadFileService {
    gatewayNewBaseUrl = environment.baseAPIUrl;

    private httpClient = inject(HttpClient);

    downloadFile(fileId: string): Observable<string> {
        return this.httpClient.get<string>(`${this.gatewayNewBaseUrl}/file-uploads/api/v1/SecureStorage/download/${fileId}`);
    }
    
}